import { CdrImg as m } from "@rei/cedar";
import { resolveComponent as o, openBlock as a, createElementBlock as d, createCommentVNode as s, createBlock as u, normalizeClass as h } from "vue";
const f = (e, c) => {
  const t = e.__vccOpts || e;
  for (const [i, n] of c)
    t[i] = n;
  return t;
}, g = {
  /* c8 ignore start */
  name: "ImageComponent",
  components: {
    CdrImg: m
  },
  props: {
    media: {
      type: Object,
      required: !0
    },
    lazyLoad: {
      type: Boolean,
      required: !1,
      default: !0
    },
    fetchPriority: {
      type: String,
      required: !1,
      default: ""
    },
    customClasses: {
      type: String,
      required: !1,
      default: ""
    },
    ariaHidden: {
      type: String,
      required: !1,
      default: "false"
    }
  },
  computed: {
    loading() {
      return this.lazyLoad && "lazy";
    },
    computedFetchPriority() {
      var e;
      return (e = this.fetchPriority) != null && e.length ? this.fetchPriority : null;
    },
    alt() {
      return this.media && this.media.alt || "";
    },
    srcXs() {
      return this.media && this.media.xs || "";
    },
    srcSm() {
      return this.media && this.media.sm || "";
    },
    srcMd() {
      return this.media && this.media.md || "";
    },
    srcLg() {
      return this.media && this.media.lg || "";
    },
    ratio() {
      var e;
      return (e = this.media) == null ? void 0 : e.ratio;
    },
    crop() {
      var e;
      return (e = this.media) == null ? void 0 : e.crop;
    },
    cover() {
      var e;
      return (e = this.media) == null ? void 0 : e.cover;
    },
    radius() {
      var e;
      return (e = this.media) == null ? void 0 : e.radius;
    },
    containerClass() {
      var e;
      return (e = this.media) == null ? void 0 : e.containerClass;
    },
    srcFallback() {
      const {
        srcLg: e,
        srcMd: c,
        srcSm: t,
        srcXs: i
      } = this;
      return e || c || t || i || "";
    }
  }
  /* c8 ignore end */
}, y = {
  key: 0,
  "data-ui": "landing-image-component"
}, _ = ["srcset"], p = ["srcset"], k = ["srcset"];
function C(e, c, t, i, n, r) {
  const l = o("cdr-img");
  return t.media ? (a(), d("picture", y, [r.srcXs ? (a(), d("source", {
    key: 0,
    srcset: r.srcXs,
    media: "(max-width: 767px)"
  }, null, 8, _)) : s("", !0), r.srcSm ? (a(), d("source", {
    key: 1,
    srcset: r.srcSm,
    media: "(max-width: 991px)"
  }, null, 8, p)) : s("", !0), r.srcMd ? (a(), d("source", {
    key: 2,
    srcset: r.srcMd,
    media: "(max-width: 1231px)"
  }, null, 8, k)) : s("", !0), r.srcFallback ? (a(), u(l, {
    key: 3,
    ref: "img",
    alt: r.alt,
    src: r.srcFallback,
    loading: r.loading,
    fetchpriority: r.computedFetchPriority,
    class: h(t.customClasses),
    "container-class": r.containerClass,
    ratio: r.ratio,
    crop: r.crop,
    cover: r.cover,
    radius: r.radius,
    "aria-hidden": t.ariaHidden
  }, null, 8, ["alt", "src", "loading", "fetchpriority", "class", "container-class", "ratio", "crop", "cover", "radius", "aria-hidden"])) : s("", !0)])) : s("", !0);
}
const S = /* @__PURE__ */ f(g, [["render", C]]);
export {
  S as default
};
